import { VpSticker } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

export const PrioritySticker = () => {
  const { t } = useTranslation('common')
  return (
    <VpSticker
      data-testid="priority-sticker"
      variant="neutral"
      size="small"
      className="h-5 font-normal"
    >
      {t('global.priority')}
    </VpSticker>
  )
}
